import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { FeatureCards } from '../components/FeatureCards';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen flex flex-col font-sans bg-white" data-id="element-135">
      <Navbar data-id="element-136" />
      <main className="flex-grow" data-id="element-137">
        <HeroSection data-id="element-138" />
        <FeatureCards data-id="element-139" />
      </main>
      <Footer data-id="element-140" />
    </div>;
}